import api from './api';

export interface Circuito {
  id: number;
  identificacao: string;
  caixa_id: number;
  endereco: string;
  situacao: 'ocupado' | 'livre';
  usuarioId_criou: number;
  contrato_id?: number | null;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  caixa?: {
    id: number;
    name: string;
    address: string;
    capacidade?: number;
  };
  usuario_criou?: {
    id: number;
    nome: string;
  };
  contrato?: {
    id: number;
    titulo: string;
    cliente?: {
      id: number;
      nome: string;
    };
  };
}

export interface FtthCaixa {
  id: number;
  name: string;
  address: string;
}

export interface CircuitStats {
  caixa_id: number;
  total: number;
  livres: number;
  ocupados: number;
  caixa: {
    id: number;
    name: string;
    address: string;
  };
}

export interface CircuitFilters {
  page?: number;
  limit?: number;
  caixa_id?: number;
  situacao?: 'ocupado' | 'livre';
  search?: string;
}

export interface CircuitListResponse {
  circuitos: Circuito[];
  total: number;
  page: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export interface CreateCircuitData {
  identificacao: string;
  caixa_id: number;
  endereco: string;
  situacao?: 'ocupado' | 'livre';
  contrato_id?: number;
}

export interface UpdateCircuitData {
  identificacao?: string;
  caixa_id?: number;
  endereco?: string;
  situacao?: 'ocupado' | 'livre';
}

class CircuitService {
  // Listar circuitos com filtros
  async getCircuitos(filters: CircuitFilters = {}): Promise<CircuitListResponse> {
    console.log('🔧 Filtros no circuitService:', filters);
    const params = new URLSearchParams();

    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    if (filters.caixa_id) params.append('caixa_id', filters.caixa_id.toString());
    if (filters.situacao) params.append('situacao', filters.situacao);
    if (filters.search) params.append('search', filters.search);

    const response = await api.get(`/circuitos?${params.toString()}`);
    return response as unknown as CircuitListResponse;
  }

  // Buscar circuito por ID
  async getCircuito(id: number): Promise<Circuito> {
    const response = await api.get(`/circuitos/${id}`);
    return response as unknown as Circuito;
  }

  // Criar circuito
  async createCircuit(data: CreateCircuitData): Promise<{ message: string; circuit: Circuito }> {
    const response = await api.post('/circuitos', data);
    return response as unknown as { message: string; circuit: Circuito };
  }

  // Atualizar circuito
  async updateCircuit(id: number, data: UpdateCircuitData): Promise<{ message: string; circuit: Circuito }> {
    const response = await api.put(`/circuitos/${id}`, data);
    return response as unknown as { message: string; circuit: Circuito };
  }

  // Deletar circuito
  async deleteCircuit(id: number): Promise<{ message: string }> {
    const response = await api.delete(`/circuitos/${id}`);
    return response as unknown as { message: string };
  }

  // Listar CAIXAs para select
  async getCaixas(): Promise<FtthCaixa[]> {
    const response = await api.get('/circuitos/caixas');
    return response as unknown as FtthCaixa[];
  }

  // Obter estatísticas por CAIXA
  async getStatsByCaixa(): Promise<CircuitStats[]> {
    const response = await api.get('/circuitos/stats');
    return response as unknown as CircuitStats[];
  }
}

export default new CircuitService(); 